<template>
	<svg id="svg-201801181505-wait" viewBox="0 0 59 3" preserveAspectRatio="xMidYMid meet" :style="{width:width, height:height}">
		<rect x="56" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.93s" repeatCount="indefinite"/>
		</rect>
		<rect x="52" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.87s" repeatCount="indefinite"/>
		</rect>
		<rect x="48" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.8s" repeatCount="indefinite"/>
		</rect>
		<rect x="44" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.73s" repeatCount="indefinite"/>
		</rect>
		<rect x="40" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.67s" repeatCount="indefinite"/>
		</rect>
		<rect x="36" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.6s" repeatCount="indefinite"/>
		</rect>
		<rect x="32" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.53s" repeatCount="indefinite"/>
		</rect>
		<rect x="28" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.47s" repeatCount="indefinite"/>
		</rect>
		<rect x="24" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.4s" repeatCount="indefinite"/>
		</rect>
		<rect x="20" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.33s" repeatCount="indefinite"/>
		</rect>
		<rect x="16" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.26s" repeatCount="indefinite"/>
		</rect>
		<rect x="12" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.2s" repeatCount="indefinite"/>
		</rect>
		<rect x="8" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.13s" repeatCount="indefinite"/>
		</rect>
		<rect x="4" y="0" width="3" height="3" opacity="0.2">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" begin="0.06s" repeatCount="indefinite"/>
		</rect>
		<rect x="0" y="0" width="3" height="3" opacity="1">
			<animate attributeType="CSS" attributeName="opacity" values="1;0.2" dur="1s" fill="remove" repeatCount="indefinite"/>
		</rect>
	</svg>
</template>

<script>
import base from '@/components/base.vue';
export default {
	mixins: [base],
	name: 'waitBar',
	props: {
		width: {},
		height: {},
		fill: {}
	},
	mounted() {
		this.$nextTick(function(){
			var _self = this;
			var rects = this.$el.getElementsByTagName('rect');
			var node = Array.prototype.slice.call(rects, 0);
			node.forEach(function(elem, index){
				elem.style.fill = _self.fill;
			});
		});
	}
}
</script>

<style lang="less" scoped>
@import '../../less/const.less';
#svg-201801181505-wait rect {
	fill: white;
}
</style>



// WEBPACK FOOTER //
// src/components/component/wait-bar.vue